import { useTranslation } from "react-i18next";
import ActivityLog from "./package-audit-trail.jsx";
import PackageBasicInformation from "./package-basic-information.jsx";
import PackageOwnerInformation from "./package-owner-information.jsx";
import PackageParticipantsLists from "./package-participants-lists.jsx";

const PackageInformation = ({currentPackage}) => {

    const { t } = useTranslation();

    return (
        <>
            <PackageBasicInformation
                packageInfo={currentPackage}
            />
            <div className="package-information__container">
                <div className="package-information__left-sub-container">
					{currentPackage.owners && currentPackage.owners?.length > 0 && (
						<PackageOwnerInformation
							title={t("Owner")}
							packageInfo={currentPackage}
						/>
					)}
                    <PackageParticipantsLists
                        title={t("Participants")}
                        packageInfo={currentPackage}
                    />
                </div>
                <div className="package-information__right-sub-container">
                    <ActivityLog
                        title={t("activityLog")}
                        packageInfo={currentPackage}
                    />
                </div>
            </div>
        </>
    )

};

export default PackageInformation;
